<template>
    <div class="text-followup-nav mb-5">
        <div v-if="project" class="text-2xl text-grey-darkest mb-4">Project Resources</div>
        <div v-else-if="company" class="text-2xl text-grey-darkest mb-4">Client Resources</div>
        <div v-else class="text-2xl text-grey-darkest mb-4">Resources</div>
        <div v-if="this.company || this.project" class="text-teal hover:text-teal-dark font-base text-sm mb-4">
            <div @click="goBack" class="flex cursor-pointer">
                <span class="material-icons">chevron_left</span>
                <span>Back</span>
            </div>
        </div>
        <div class="text-xl text-grey-darkest mb-4">Project Folder Structure</div>
        <div class="flex folder items-center pointer hover:bg-grey-lighter" v-for="folder in foldersList" :key="folder.id" @click="viewResourceFiles(folder)">
            <div class="w-1/6 text-left">{{ folder.name }}</div>
            <div class="flex-1 text-left"><small class="ml-5">{{ folder.total_resources }} items</small></div>
        </div>
    </div>
</template>

<script>
    import Form from "../../utils/form";
    import _ from 'lodash';
    export default {
        name: "folders-list",
        props: ['folders', 'project', 'company'],
        data() {
            return {
                foldersList: this.folders
            }
        },

        mounted() {
            Bus.$on('resourceMoved', data => {
                this.updateFolderInfos(data.folderId);
            });
        },

        methods: {
            viewResourceFiles(folder) {
                window.location = route('project.resource-files', {project: this.project, folder: folder.id});
            },

            goBack() {
                window.location = this.company ? route('company.show', {company: this.company}) : route(`${this.isPm ? 'project-management.' : ''}project.edit`, {project: this.project});
            },

            updateFolderInfos(folderId) {
                const params = {
                    project_id: this.project,
                    folder_id: folderId,
                };

                axios.get(route('api.resource-files.file-folder.info'), {params}).then(({data}) => {
                   const idx = _.findIndex(this.folders, {id: folderId});
                   this.$set(this.foldersList, idx, data);
                });
            },
        }
    }
</script>

<style scoped>
    .folder:before {
        font-family: 'FontAwesome';
        content: "\f07b";
        display: inline-block;
        padding-right: 5px;
        vertical-align: middle;
        font-weight: 900;
        font-size: 30px;
    }
</style>
